import React from 'react';
import {
    ComposedChart,
    Bar,
    Line,
    XAxis,
    YAxis,
    CartesianGrid,
    Tooltip,
    Legend,
    ResponsiveContainer,
    ReferenceLine
} from 'recharts';

export default function CostFundingChart({ yearlyResults }) {
    if (!yearlyResults || yearlyResults.length === 0) return null;

    // Filter to active years only (where totalSpending > 0)
    const data = yearlyResults
        .filter(d => d.totalSpending > 0)
        .map(d => ({
            year: d.year,
            // Costs (stacked bar components roughly)
            totalCost: d.totalSpending / 1e9,

            // Funding Sources (we could stack these, but total funding line is cleaner for balance)
            totalFunding: d.totalRevenue / 1e9,

            // Balance
            balance: (d.totalRevenue - d.totalSpending) / 1e9
        }));

    return (
        <div className="chart-container">
            <h4 style={{ textAlign: 'center', marginBottom: '1.5rem', color: 'var(--text-primary)', fontWeight: 800 }}>
                Annual Program Balance (Billions)
            </h4>
            <div style={{ height: '500px', width: '100%' }}>
                <ResponsiveContainer width="100%" height="100%">
                    <ComposedChart
                        data={data}
                        margin={{ top: 10, right: 30, left: 20, bottom: 5 }}
                    >
                        <CartesianGrid strokeDasharray="3 3" vertical={false} stroke="var(--bg-tertiary)" />
                        <XAxis dataKey="year" stroke="var(--text-secondary)" tick={{ fill: 'var(--text-muted)', fontSize: '11px', fontWeight: 600 }} />
                        <YAxis
                            tickFormatter={(value) => `$${value}B`}
                            stroke="var(--text-secondary)"
                            tick={{ fill: 'var(--text-muted)', fontSize: '11px', fontWeight: 600 }}
                        />
                        <Tooltip
                            contentStyle={{
                                backgroundColor: 'rgba(255, 255, 255, 0.96)',
                                border: '1px solid var(--glass-border)',
                                borderRadius: '12px',
                                color: 'var(--text-primary)',
                                boxShadow: '0 10px 15px -3px rgba(0, 0, 0, 0.1)',
                                fontSize: '13px'
                            }}
                            formatter={(value) => [`$${parseFloat(value).toFixed(1)}B`, '']}
                        />
                        <Legend
                            verticalAlign="bottom"
                            align="center"
                            wrapperStyle={{ color: 'var(--text-primary)', fontSize: '11px', fontWeight: 600, paddingTop: '10px' }}
                        />
                        <ReferenceLine y={0} stroke="var(--text-muted)" />

                        <Bar dataKey="totalCost" name="Total Cost" fill="#fa5252" barSize={20} />
                        <Bar dataKey="totalFunding" name="Total Funding" fill="#16a34a" barSize={20} />
                        <Line
                            type="monotone"
                            dataKey="balance"
                            name="Net Balance (+/-)"
                            stroke="#fab005"
                            strokeWidth={3}
                            dot={{ r: 4, fill: '#fab005' }}
                        />
                    </ComposedChart>
                </ResponsiveContainer>
            </div>
            <p className="chart-note" style={{ textAlign: 'center', color: 'var(--text-muted)', fontWeight: 600, marginTop: '10px' }}>
                Positive balance = Surplus (goes to Trust Fund) | Negative = Deficit (draws from Trust Fund)
            </p>
        </div>
    );
}
